<nz-modal
    [(nzVisible)]="isIdImagesModalVisible"
    [nzTitle]="idImagesTitle"
    (nzOnCancel)="isIdImagesModalVisible = false"
    [nzFooter]="idModalFooter"
    nzWidth="720px"
>
    <ng-container *nzModalContent>
        <nz-spin *ngIf="idFilesLoading && idFiles.length === 0" nzSimple></nz-spin>

        <!-- Read-only drug-card detail -->
        <ng-container *ngIf="activeIdFilter === 'drugCard'; else idFileGrid">
            <div class="flex flex-wrap gap-4">
                <nz-card
                    *ngFor="let card of drugCards"
                    style="width: 220px"
                    [nzTitle]="getDrugCardTypeLabel(card.type) || 'Drug card'"
                >
                    <div
                        *ngIf="card.relationshipToCardholder"
                        style="margin-bottom: 6px; font-size: 12px"
                    >
                        <strong>Relationship:</strong>
                        {{ card.relationshipToCardholder }}
                    </div>
                    <ng-container *ngIf="getDrugCardSides(card) as sides">
                        <div
                            *ngFor="let side of sides"
                            style="margin-bottom: 10px"
                        >
                            <div
                                *ngIf="sides.length > 1"
                                style="font-size: 11px; color: #666; margin-bottom: 4px"
                            >
                                {{ side.label }}
                            </div>
                            <ng-container
                                *ngIf="getCardFile(side.fileKey) as file; else sideLoadingTpl"
                            >
                                <div
                                    *ngIf="isCardImageMime(side.fileKey)"
                                    style="text-align: center; margin-bottom: 4px"
                                >
                                    <img
                                        [src]="getIdImageSrc(file)"
                                        (click)="openCardSide(side.fileKey)"
                                        style="max-width: 100%; max-height: 120px; object-fit: contain; cursor: pointer"
                                        [alt]="side.label + ' drug card'"
                                    />
                                </div>
                                <div
                                    *ngIf="!isCardImageMime(side.fileKey)"
                                    style="text-align: center; margin-bottom: 4px"
                                >
                                    <button
                                        nz-button
                                        nzType="link"
                                        type="button"
                                        (click)="openCardSide(side.fileKey)"
                                    >
                                        View file ({{ side.label }})
                                    </button>
                                </div>
                            </ng-container>
                            <ng-template #sideLoadingTpl>
                                <div
                                    style="text-align: center; color: #999; font-size: 12px"
                                >
                                    Loading {{ side.label | lowercase }}…
                                </div>
                            </ng-template>
                        </div>
                        <div
                            *ngIf="sides.length === 0"
                            style="text-align: center; color: #999"
                        >
                            No image on file
                        </div>
                    </ng-container>
                </nz-card>
                <span
                    *ngIf="!idFilesLoading && drugCards.length === 0"
                    class="text-gray-400 text-sm"
                >No drug cards on file</span>
            </div>
        </ng-container>

        <!-- Flat ID / selfie grid -->
        <ng-template #idFileGrid>
            <div class="flex flex-wrap gap-4">
                <div
                    *ngFor="let file of getDisplayedIdFiles()"
                    class="text-center"
                >
                    <nz-spin [nzSpinning]="!file.loaded">
                        <div
                            *ngIf="!file.buffer"
                            style="width:160px;height:100px;background:#f5f5f5;border:1px solid #d9d9d9;border-radius:4px;display:flex;align-items:center;justify-content:center"
                        >
                            <i class="fa-solid fa-image text-gray-400 text-2xl"></i>
                        </div>
                        <img
                            *ngIf="file.buffer"
                            [src]="getIdImageSrc(file)"
                            (click)="openIdImage(file)"
                            class="cursor-pointer rounded border"
                            style="max-height:160px;max-width:200px;object-fit:contain"
                            alt="{{ getIdFileLabel(file.name) }}"
                        />
                    </nz-spin>
                    <div class="text-xs mt-1 text-gray-500">
                        {{ getIdFileLabel(file.name) }}
                    </div>
                    <div class="text-xs text-gray-400">
                        {{ (file.updatedAt || file.createdAt) | date: 'MMM d, yyyy' }}
                    </div>
                </div>
                <span
                    *ngIf="!idFilesLoading && getDisplayedIdFiles().length === 0"
                    class="text-gray-400 text-sm"
                >No documents on file</span>
            </div>
        </ng-template>
    </ng-container>
</nz-modal>

<ng-template #idModalFooter>
    <button nz-button nzType="default" (click)="isIdImagesModalVisible = false">
        Close
    </button>
    <button
        *ngIf="activeIdFilter !== 'drugCard' && IDVerificationStatus !== 'verified'"
        nz-button
        nzType="primary"
        (click)="markIDAsVerified()"
    >
        <i class="fa-solid fa-check mr-1"></i>Mark ID as Verified
    </button>
    <button
        *ngIf="activeIdFilter !== 'drugCard' && IDVerificationStatus === 'verified' && IDVerifiedBy !== 'Persona'"
        nz-button
        nzType="default"
        [nzDanger]="true"
        (click)="markUnverifyID()"
    >
        Unverify ID
    </button>
</ng-template>

<nz-modal
    [(nzVisible)]="isExpiryModalVisible"
    nzTitle="Set ID Verification Expiry Date"
    (nzOnCancel)="handleExpiryDateCancel()"
    (nzOnOk)="handleExpiryDateOk()"
    [nzOkDisabled]="!expiryDate"
>
    <ng-container *nzModalContent>
        <nz-date-picker
            [(ngModel)]="expiryDate"
            nzFormat="MM/dd/yyyy"
            nzPlaceHolder="Select expiry date"
            style="display: block; width: 100%"
        ></nz-date-picker>
    </ng-container>
</nz-modal>

<nz-modal
    [(nzVisible)]="isVerificationConfirmationModalVisible"
    nzTitle="Confirm ID Unverification"
    (nzOnCancel)="handleVerificationConfirmationCancel()"
    (nzOnOk)="handleVerificationConfirmationOk()"
>
    <ng-container *nzModalContent>
        <p>Are you sure you want to set ID as unverified?</p>
    </ng-container>
</nz-modal>
